<template>
    <div>
        <MenuComp />

        <br>

        <v-row>
            <v-col>
                <EntradaComp />
            </v-col>

            <v-col>
                <SaidaComp />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import SaidaComp from './components/TabelaSaidaComp'
import EntradaComp from './components/TabelaEntradaComp'
import MenuComp from './components/MenuComp';

export default {
    name: 'FinancasView',

    components: {
        SaidaComp,
        EntradaComp,
        MenuComp
    }

}
</script>
